import { render } from "./BlockquoteIcon.vue?vue&type=template&id=f568cd8c"
import script from "./BlockquoteIcon.vue?vue&type=script&lang=js"
export * from "./BlockquoteIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nicedate.elena-dating.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__